<template>
  <div style=" width: 100%;
  overflow: hidden;" ondragstart="return false" oncontextmenu="return false">
    <ei-header :header2-show="true" :header2-lit="true"></ei-header>
    <DropdownPluginWriter style="margin-left: 128px;position: absolute;margin-top: 620px;z-index: 9999"
                         :lieWidth="lieWidth" :lieHeight="lieHeight" :lieFontSzie="lieFontSzie" :lieMarginLeft="lieMarginLeft"

    >
    </DropdownPluginWriter>
    <DropdownPluginPainter style="margin-left: 1810px;position: absolute;margin-top: 620px;z-index: 9999"
                           :lieWidth="lieWidth" :lieHeight="lieHeight" :lieFontSzie="lieFontSzie" :lieMarginLeft="lieMarginLeft"

    >
    </DropdownPluginPainter>

    <ei-works-detail :works="works" :person="person"
                     :videoFrequency="videoFrequency" :allVideoFrequency="allVideoFrequency"
                     :headText="headText"
                     :descriptionText="descriptionText" :musicAttach="musicAttach" :isUsedList="isUsedList" :noUsedList="noUsedList"
                     :workWdith="workWdith"
    ></ei-works-detail>
    <ei-footer></ei-footer>
  </div>
</template>

<script>
import {
  queryWorksDetailAction,
  queryPersonByWorksGuid,
  queryPersonAndWorksDescription,
  queryMusicByWorks,
  queryStarLightList,
  calculatedWidthByWork,
  queryVideoFrequencyByWorkId,
} from '@/api/reception/works-api'
import {isFailure} from '@/eiuov-utils/axios/response'


export default {
  name: 'WorksDetail',
  data() {
    return {
      rowGuid: '',
      works: {},
      person: {},
      videoFrequency:[],
      allVideoFrequency:[],
      headText:'',
      descriptionText: '',
      musicAttach: {},
      isUsedList: [],
      noUsedList:[],
     /* noUsedLight: [],
      isUsedLight: [],*/
      lieWidth:31,
      lieHeight:28,
      lieMarginLeft:-50,
      lieFontSzie:23,
      workWdith:0,

    }
  },
  inject: ['reload'],
  watch: {
    '$route'(to, from) {
      this.$set(this, 'rowGuid', to.query.guid)
      this.reload()
    }
  },
  created() {
    this.rowGuid = this.$route.query.guid
    queryPersonByWorksGuid({rowGuid: this.rowGuid}).then((res) => {
      if (isFailure(res)) return
      this.person = res.data.person
    })

    queryWorksDetailAction({rowGuid: this.rowGuid}).then((res) => {
      if (isFailure(res)) return
      this.works = res.data.works
      if(this.works.videoUrl){
        queryVideoFrequencyByWorkId({rowGuid: this.rowGuid}).then((res) => {
          if (isFailure(res)) return
          this.videoFrequency= res.data.videoFrequencyListJs;
          this.allVideoFrequency=res.data.allVideoFrequencyList;
        })
      }
    })
    queryPersonAndWorksDescription({rowGuid: this.rowGuid}).then((res) => {
      if (isFailure(res)) return
      this.headText = res.data.headText
      this.descriptionText = res.data.descriptionText
    })
    calculatedWidthByWork({rowGuid: this.rowGuid}).then((res) => {
      if (isFailure(res)) return
      this.workWdith = res.data.workWdith
      console.log('--------+++++++++++')
      console.log(this.workWdith)
    })
    queryStarLightList({query: ''}).then((res) => {
      if (isFailure(res))
        return
      this.isUsedList = res.data.isUsedList
      this.noUsedList = res.data.noUsedList
    })
  },
}

</script>

<style scoped lang="scss">
* img, span, a, div {
  user-select: none;
  -webkit-user-drag: none;
}
</style>
